import { render } from "./Information.vue?vue&type=template&id=45f47700&scoped=true"
import script from "./Information.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Information.vue?vue&type=script&charset=utf-8&lang=js"

import "./Information.vue?vue&type=style&index=0&id=45f47700&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f47700"]])

export default __exports__